<template>
<div id="">
  <v-container fluid class="pt-0 ">
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card style="min-height:85vh" class="admin_secondary">
          <v-card-title class="secondary white--text">
            Payments
            <v-spacer></v-spacer>
            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
          </v-card-title>
          <v-container class=" white--text">
            <v-row align="center">

              <v-col cols="12" md="4" lg="3" xl="2">
                <v-text-field v-model="search" append-icon="fa-search" dark label="Search" outlined hide-details clearable></v-text-field>
              </v-col>

              <v-col cols="12" md="4" lg="3" xl="2">
                <v-select outlined hide-details clearable dark label="Status" placeholder="All" :items="filters" v-model="filter"></v-select>
              </v-col>

            </v-row>
            <v-data-table :loading="loading"  :headers="headers" :items="invoiceList" :search="search">
              <template v-slot:item.account.name="{ item }">
                <router-link  :to="`/admin/users/${item.account.id}`">{{item.account.name}}</router-link>
                </template>

              <template v-slot:item.date_added="{ item }">
                      {{item.date_added | dateFormat}}
                </template>

              <template v-slot:item.total_project_payments="{ item }">
                  {{item.total_project_payments | decimal}}
                    </template>

              <template v-slot:item.total_support_payments="{ item }">
                        {{item.total_support_payments | decimal}}
                          </template>


              <template v-slot:item.average_pay_per_video="{ item }">
                        {{item.average_pay_per_video | decimal}}
                          </template>


              <template v-slot:item.total="{ item }">
                                                  {{item.total | decimal}}
                                                    </template>

              <template v-slot:item.paypal_receipt="{ item }">
                <v-container class="pa-0">
                  <v-row  v-if="item.paypal_receipt">
                      <v-text-field readonly hide-details outlined dense :value="item.paypal_receipt"></v-text-field>
                  </v-row>
                  <v-row  v-else>
                    <v-col cols="12">
                      <v-text-field hide-details outlined dense @change="receiptInvoice({paypal_receipt: $event, invoice: item})" ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>

            </template>



              <template v-slot:item.status="{ item }">
                    <v-btn :href="`${item.account.paypal_link}/${item.total/100}usd`" target="_blank" small dark color="green" v-if="item.status===0">Pay now</v-btn>
                    <span v-else class="green--text">Paid</span>
              </template>

              <template v-slot:item.notification="{ item }">
                    <v-btn icon small color="primary" @click="$eventBus.$emit('send_notification',{account:item.account})"><v-icon small>fa-paper-plane</v-icon></v-btn>
                  </template>


            </v-data-table>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</div>
</template>
<script>
import headersSimple from "./headers_simple.json"


export default {
  name: "",
  data: () => ({
    search: '',
    filter: '',
    filters: ['Pending', 'Paid'],
    loading: false,
    invoices: [],
    accounts: []
  }),
  computed: {
    headers() {
      return headersSimple
    },
    invoiceList() {
      return this.invoices.filter(function(invoice) {
        if (this.filter) {
          if (this.filter === "Pending") {
            return invoice.status === 0
          } else {
            return invoice.status === 1
          }
        } else {
          return true
        }
      }.bind(this)).map(function(invoice) {

        invoice.account = this.accounts.find(a => {
          return a.id === invoice.account_id
        })

        let total_project_payments = 0;
        invoice.project_reports.forEach(p => {
          total_project_payments += (p.amount_earned + p.bonus)
        })
        invoice.total_project_payments = total_project_payments;

        let total_support_payments = 0;
        invoice.support_payments.forEach(p => {
          total_support_payments += p.amount_earned
        })
        invoice.total_support_payments = total_support_payments;

        let average_pay_per_video = invoice.total_project_payments / invoice.project_reports.length;

        invoice.average_pay_per_video = average_pay_per_video;

        invoice.total = invoice.total_project_payments + invoice.total_support_payments;


        return invoice;

      }.bind(this))
    }
  },
  methods: {
    async load() {
      this.loading = true
      await Promise.all([this.loadAccounts(), this.loadInvoices()])
      this.loading = false
    },
    async loadAccounts() {
      this.accounts = await this.$api(`/account/admin/accounts`)
    },
    async loadInvoices() {
      this.invoices = await this.$api(`/account/admin/invoices`)
    },
    async receiptInvoice(options) {
      if (!confirm("Update paypal receipt and mark as paid?")) {
        return;
      }
      try {
        await this.$api({
          method: "POST",
          url: `account/admin/invoices/${options.invoice.id}`,
          data: {
            paypal_receipt: options.paypal_receipt,
            status: 1
          }
        })
        this.load()
      } catch (ex) {
        alert(ex.error)
      }
    }
  },
  created() {
    this.load()
  }
}
</script>
<style lang="scss" scoped>
</style>
